'use client';

import * as NFA from '@next-firebase/auth/provider';

import { setup, UserRole } from 'config/auth';
import { firebaseConfig } from 'services/firebase/config';

interface AuthContextProps {
	children: React.ReactNode;
}

export function AuthContextProvider(props: AuthContextProps) {
	return (
		<NFA.NFAProvider setup={setup} firebaseConfig={firebaseConfig}>
			{props.children}
		</NFA.NFAProvider>
	);
}

export const useAuth = () => NFA.useNFA<UserRole>();
